import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type {
  ListEnvelopeAccessLinksParams,
  ListEnvelopeAccessLinksResponse,
} from './access-links.types'

export const ENVELOPE_ACCESS_LINKS_QUERY_KEY = 'envelope-access-links'

const listEnvelopeAccessLinks = async (
  envelopeId: string,
  params: ListEnvelopeAccessLinksParams,
): Promise<ListEnvelopeAccessLinksResponse> => {
  const response = await apiClient.get<ListEnvelopeAccessLinksResponse>(
    `/v1/ecm/envelopes/${envelopeId}/access-links`,
    { params: { PageNumber: params.pageNumber, PageSize: params.pageSize } },
  )
  return response.data
}

export const useListEnvelopeAccessLinks = (
  envelopeId: string,
  params: ListEnvelopeAccessLinksParams,
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: [ENVELOPE_ACCESS_LINKS_QUERY_KEY, envelopeId, params],
    queryFn: () => listEnvelopeAccessLinks(envelopeId, params),
    enabled: options?.enabled ?? true,
    placeholderData: keepPreviousData,
  })
}
